import { GroupTypeEnum } from '@/types/schema';

import useContentCollectionGroup from './useContentCollectionGroup';
import useUserCollectionGroup from './useUserCollectionGroup';

export default function useGroup({
  groupId,
  type,
}: {
  groupId?: string | null;
  type: GroupTypeEnum;
}) {
  const { group: learnerGroup, fetching: fetchingLearnerGroup } = useUserCollectionGroup({
    groupId: groupId!,
    pause: type === GroupTypeEnum.ContentCollection,
  });

  const { group: collections, fetching: fetchingCollections } = useContentCollectionGroup({
    groupId: groupId!,
    pause: type === GroupTypeEnum.UserCollection,
  });

  return {
    group: type === GroupTypeEnum.UserCollection ? learnerGroup : collections,
    fetching: fetchingLearnerGroup || fetchingCollections,
  };
}
